import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import RootView from "./components/root-view";
import reportWebVitals from "./reportWebVitals";
import { GameContextProvider } from "./utils/use-game-context";

ReactDOM.render(
  <React.StrictMode>
    <GameContextProvider>
      <RootView />
    </GameContextProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
